import { createQuery } from "@tanstack/solid-query";
import { For, Show } from "solid-js";
import { StatusPill } from "~/components/StatusPill";
import { fetchCompanies } from "~/lib/api";
import { stackPreview } from "~/lib/company-stack";

type Props = {
  enabled: boolean;
  onOpenIndex: () => void;
  onOpenCompany: (slug: string) => void;
};

export function CompanyIntelEntry(props: Props) {
  const listQuery = createQuery(() => ({
    queryKey: ["companies", { homePreview: true }],
    queryFn: () => fetchCompanies({ limit: 5 }),
    enabled: props.enabled,
  }));

  const featured = () => {
    const items = listQuery.data?.data ?? [];
    return items.find((c) => c.hiring) ?? items[0];
  };

  const preview = () => stackPreview(featured()?.stack, 2);

  function open() {
    const card = featured();
    if (card) {
      props.onOpenCompany(card.slug);
      return;
    }
    props.onOpenIndex();
  }

  return (
    <button type="button" class="company-intel-entry" onClick={open}>
      <div class="company-card-top">
        <span class="status-chip">Company intel</span>
        <span class="company-card-status">
          <Show when={featured()?.hiring}>
            <StatusPill variant="hiring" />
          </Show>
        </span>
      </div>
      <Show
        when={featured()}
        keyed
        fallback={<strong class="company-card-name">Stacks, presence, and observed roles</strong>}
      >
        {(card) => (
          <strong class="company-card-name">
            {card.canonical_name}
            {card.locations ? ` · ${card.locations}` : ""}
          </strong>
        )}
      </Show>
      <Show when={preview().length}>
        <div class="company-card-tags">
          <For each={preview()}>{(tag) => <span class="skill-chip">{tag}</span>}</For>
        </div>
      </Show>
    </button>
  );
}
